export const environment = {
  production: false,
  BaseUrl: 'https://apis.srv1954566.hstgr.cloud/api',
  /**
   * El servicio de IDENTIDAD, que contesta `GET /sesion/actual`.
   *
   * QA vive entero bajo `.srv1954566.hstgr.cloud`, igual que dev, asi que aqui
   * NO aplica el corte de dominio que mantiene vacio al ambiente de produccion
   * —ahi las apps estan en `sinay.com.mx` y las APIs en `sinay.mx`, sufijos
   * publicos distintos que ninguna cookie abarca—. Por eso este valor es
   * simplemente el de dev con `dev.` cambiado por `qa.`.
   *
   * ⚠️ **Lo que falta no es esta linea: es el despliegue.** Medido el 2026-10-07,
   * `https://srv1954566.hstgr.cloud/api/v1/sesion/actual` devuelve **200 con
   * el HTML** de la galeria «SINAY Components» —el catch-all del host—, mientras
   * el mismo camino en dev devuelve 401 en `application/json`, que es lo que
   * contesta identidad sin sesion. **Un 200 ahi NO significa que funcione**: el
   * front recibe HTML donde espera JSON, no resuelve la sesion y manda al login.
   *
   * O sea que hasta que identidad se levante en qa, esta linea esta puesta y no
   * surte efecto. Se deja puesta a proposito: el valor es correcto, es el mismo
   * en los nueve frontends, y descubrir el dia del despliegue que faltaba en seis
   * repos cuesta mas que tenerlo escrito.
   */
  identidadUrl: 'https://srv1954566.hstgr.cloud/api/v1',
  logoutUrl: 'https://srv1954566.hstgr.cloud/',
  socketUrl: 'http://localhost:3000',
};
